export var getActionsFromJsonLd = function getActionsFromJsonLd(jsonLd) {
  var actions = jsonLd && jsonLd['schema:potentialAction'];
  if (!actions) {
    return [];
  }
  if (actions && !Array.isArray(actions)) {
    actions = [actions];
  }
  return actions;
};